import { ISelectOption } from './form';

export type ScheduleType =
  | 'GATHERING'
  | 'MOVE'
  | 'MEAL'
  | 'VOLUNTEER'
  | 'LODGING'
  | 'PROGRAM'
  | 'ETC';

export const SCHEDULE_TYPE_MAP: Record<ScheduleType, string> = {
  GATHERING: '집결',
  MOVE: '이동',
  MEAL: '식사',
  VOLUNTEER: '봉사',
  LODGING: '숙소',
  PROGRAM: '프로그램',
  ETC: '기타',
};

export const SCHEDULE_TYPE_SELECT: ISelectOption<ScheduleType>[] = (
  Object.keys(SCHEDULE_TYPE_MAP) as ScheduleType[]
).map((value) => ({ name: SCHEDULE_TYPE_MAP[value], value }));

export interface IScheduleItem {
  id: string;
  date: string;
  startTime: string;
  endTime: string | null;
  title: string;
  summary: string | null;
  type: ScheduleType | null;
  description: string | null;
  place: string | null;
  notice: string | null;
}

export type ScheduleItemInputType = Omit<IScheduleItem, 'id'> & {
  id?: string;
};

export interface IEventSchedule {
  eventId: number;
  title: string;
  dates: string[];
  published: boolean;
  version: number | null;
  items: IScheduleItem[];
}

export type PutEventScheduleType = {
  eventId: number;
  items: ScheduleItemInputType[];
  version?: number;
};

export type PatchEventSchedulePublishedType = {
  eventId: number;
  published: boolean;
};
